"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const core_1 = require("@material-ui/core");
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const TGPageLabelWrapper_1 = __importDefault(require("./TGPageLabelWrapper"));
const TGPageDateTimeField = props => {
    const { readOnly, translateFunction = text => text } = props;
    const { defaultDateTimeFormat } = props;
    const label = (react_1.default.createElement(TGPageLabelWrapper_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, tooltip: false, oneLine: props.oneLine, translateFunction: translateFunction }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Typography, { style: {
                wordWrap: 'break-word',
                fontFamily: 'Roboto,Roboto-Light',
            }, component: "div" },
            react_1.default.createElement("div", { style: Object.assign({ margin: 0, fontWeight: 300, fontSize: 14, lineHeight: '130%' }, (props.truncate
                    ? {
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }
                    : undefined)) },
                label,
                react_1.default.createElement("span", { style: { color: props.value ? undefined : '#AAAAAA' } }, props.value
                    ? (0, moment_1.default)(String(props.value)).format((0, gen5_shared_utilities_1.getDateTimeFormat)(defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormatType, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormat, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateSeperator, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.timeFormat, { tokenConversion: gen5_shared_utilities_1.DATETIME_TOKEN_CONVERSION.MomentJS }))
                    : '(None)')))));
};
exports.default = TGPageDateTimeField;
//# sourceMappingURL=TGPageDateTimeField.js.map